import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { SvbrgLanguage } from '@/generated/gql/graphql';
import { i18n } from '~/common/i18n';

export const intakeRequestDescriptionStepFormDataSchema = z.object({
  text: z.string().min(1),
  language: z.enum(SvbrgLanguage),
});

export type IntakeRequestDescriptionStepFormData = z.infer<typeof intakeRequestDescriptionStepFormDataSchema>;

export const intakeRequestDescriptionStepFormDataDefault: DefaultValues<IntakeRequestDescriptionStepFormData> = {
  text: '',
  language:
    !i18n.language || i18n.language === 'dx' ? SvbrgLanguage.DE : (i18n.language.toUpperCase() as SvbrgLanguage),
};
